const appConfig = {
    apiPrefix: '/api',
    apiReportsPrefix: '/api',
    apiPrefixServer: 'https://apitest.yupimap.com/api', //PRODUCTION
    //apiPrefixServer: 'https://localhost:7069/api',//'http://localhost:3050/api',  //TEST
    //apiReportsServer: 'https://localhost:44351/api', 
    authenticatedEntryPath: '/pages/welcome' ,
    AZURE_STORAGE_CONNECTION_STRING: "",
    AZURE_containername:"",
    storageAccountName: "",
    sasToken: "",
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: true
}
 
export default appConfig